<template>
  <div class="report">
    <v-row>
      <v-col class="document-title">
        <h1 v-if="params.subtype === 'ARTICLES'">Prodani artikli sumarno po artiklih</h1>
        <h1 v-if="params.subtype === 'CATEGORIES'">Prodani artikli sumarno po skupinah</h1>
        <h1 v-if="params.subtype === 'BOTH'">Prodani artikli sumarno po skupinah in artiklih</h1>
      </v-col>
    </v-row>
    <ReportPrintAllHeader :params="params" />

    <v-row class="table-header">
      <v-col>
        Ime
      </v-col>
      <v-col>
        Št. atriklov
      </v-col>
      <v-col>
        Znesek (€)
      </v-col>
    </v-row>

    <v-row v-for="item in data" :key="item.name">
      <v-col cols="4">
        {{item.name}}
      </v-col>
      <v-col cols="4">
        {{item.quantity}}
      </v-col>
      <v-col cols="4" :inner-html.prop="item.sum | price(2)">
      </v-col>
      <v-col cols="8" offset="4" v-if="item.articles">
        <v-row class="condenced" v-for="article of item.articles" :key="article.name">
          <v-col>
            <span style="color: #bababa">{{article.quantity}}x</span> {{article.name}}
          </v-col>
          <v-col :inner-html.prop="article.sum | price(2)">
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="devider" v-if="needsDevider(item)">
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="8" offset="4">
        <v-row class="table-footer">
          <v-col>Skupaj:</v-col>
          <v-col :inner-html.prop="total | price(2)"></v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ReportPrintAllHeader from './ReportPrintAllHeader'

export default {
  components: {
    ReportPrintAllHeader
  },
  props: {
    data: {
      required: true,
      type: Array
    },
    params: {
      required: true,
      type: Object
    }
  },
  computed: {
    total () {
      return this.data.reduce((total, item) => total + item.sum, 0)
    }
  },
  methods: {
    needsDevider (item) {
      if (!this.data.some(item => !!item.articles)) return false
      const itemPosition = this.data.map(i => i.name).indexOf(item.name)
      if (itemPosition === this.data.length - 1) return false
      return true
    }
  }
}
</script>

<style lang="scss">
.theme--light.v-application {
  background-color: white;
}
</style>

<style lang="scss" scoped>
html, body {
  font-size: 70%;
}
.report {
  padding: 30px 20px;
}
.document-title {
  margin-bottom: 30px;
  text-align: center;
}
.table-title {
  background-color: #eaeaea;
  font-weight: bold;
}
.table-header,
.table-footer {
  border: 1px solid black;
  background-color: #e5e5e5;
  font-weight: bold;
  font-size: 115%;
}
.devider {
  padding-top: 0px;
  margin-top: 0px;
  margin-bottom: 10px;
  border-top: 1px solid black;
}
.row.condenced {
  .col {
    padding: 5px;
  }
}
</style>
